// extracted by mini-css-extract-plugin
export default {"root":"OutsideClickHandler_root__UzuFm","selected":"OutsideClickHandler_selected__+uaf2"};